import { useEffect } from "react";
import { TextField, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import {
  JSafe,
  resetForm,
  setDialog,
} from "../../../../app/slices/jomla/safeSlice";
import { HiOutlineArchiveBox, HiOutlineIdentification } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";

const JSafeForm = () => {
  const dispatch = useDispatch();

  const _JSafe = useSelector((state) => state.jSafe.jSafe);
  const loading = useSelector((state) => state.jSafe.jSafes.loading);
  const _SearchBody = useSelector((state) => state.jSafe.searchBody);

  const isAdd = _JSafe.form.id ? false : true;
  const { control, reset, handleSubmit } = useForm({
    defaultValues: _JSafe.form,
  });

  const onSubmit = (data) => {
    if (isAdd) {
      dispatch(
        JSafe.create(
          {
            name: data.name,
          },
          _SearchBody
        )
      );
    } else {
      dispatch(
        JSafe.update(
          data.id,
          {
            name: data.name,
          },
          _SearchBody
        )
      );
    }
  };

  useEffect(() => {
    reset({ ..._JSafe.form });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_JSafe.form]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDialog = () => {
    dispatch(setDialog());
  };

  return (
    <FormDialog
      open={_JSafe.dialog}
      onClose={() => {
        handleDialog();
      }}
      maxWidth="sm"
      icon={<HiOutlineArchiveBox />}
      title={isAdd ? "إضافة خزنة جديدة" : "تعديل الخزنة"}
      subtitle={
        isAdd
          ? "أدخل معلومات الخزنة لإضافتها"
          : "قم بتحديث معلومات الخزنة ثم احفظ التغييرات"
      }
      onSubmit={handleSubmit(onSubmit)}
      saving={loading ? true : false}
      loading={_JSafe.loading}
    >
      <SectionCard icon={<HiOutlineIdentification />} title="معلومات الخزنة">
        <Grid item xs={12}>
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <TextField size="small" label="الاسم" fullWidth {...field} />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default JSafeForm;
